import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TRIP_TYPES } from "../../data/quoteOptions";
import type { QuotePrefill } from "../../data/quoteOptions";
// @ts-ignore
import "./QuickQuote.css";

export default function QuickQuote(): JSX.Element {
  const navigate = useNavigate();
  const [tripType, setTripType] = useState<string>(TRIP_TYPES[0]);
  const [pickup, setPickup] = useState("");
  const [dropoff, setDropoff] = useState("");
  const [date, setDate] = useState("");
  const [passengers, setPassengers] = useState("1");
  const [error, setError] = useState("");

  const today = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 10);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    if (!pickup.trim()) {
      setError("Enter a pickup location to continue.");
      return;
    }
    if (tripType !== "Hourly" && !dropoff.trim()) {
      setError("Enter a drop-off location to continue.");
      return;
    }
    if (!date) {
      setError("Choose your pickup date to continue.");
      return;
    }
    setError("");
    const state: QuotePrefill = { tripType, pickup, dropoff, date, passengers };
    navigate("/get-a-quote", { state });
  };

  return (
    <div className="quick-quote" id="instant-quote">
      <form className="quick-quote-form" onSubmit={handleSubmit} noValidate>
        <div className="qq-field qq-field-type">
          <label htmlFor="qq-trip-type">Trip type</label>
          <select
            id="qq-trip-type"
            value={tripType}
            onChange={(e) => setTripType(e.target.value)}
          >
            {TRIP_TYPES.map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </select>
        </div>
        <div className="qq-field qq-field-wide">
          <label htmlFor="qq-pickup">Pickup</label>
          <input
            id="qq-pickup"
            type="text"
            value={pickup}
            onChange={(e) => {
              setPickup(e.target.value);
              setError("");
            }}
            placeholder="Address, city or airport"
            autoComplete="off"
          />
        </div>
        <div className="qq-field qq-field-wide">
          <label htmlFor="qq-dropoff">
            {tripType === "Hourly" ? "Destinations (optional)" : "Drop-off"}
          </label>
          <input
            id="qq-dropoff"
            type="text"
            value={dropoff}
            onChange={(e) => {
              setDropoff(e.target.value);
              setError("");
            }}
            placeholder="Address, city or airport"
            autoComplete="off"
          />
        </div>
        <div className="qq-field">
          <label htmlFor="qq-date">Date</label>
          <input
            id="qq-date"
            type="date"
            min={today}
            value={date}
            onChange={(e) => {
              setDate(e.target.value);
              setError("");
            }}
          />
        </div>
        <div className="qq-field qq-field-pax">
          <label htmlFor="qq-passengers">Passengers</label>
          <select
            id="qq-passengers"
            value={passengers}
            onChange={(e) => setPassengers(e.target.value)}
          >
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>
        <button type="submit" className="btn gs-btn-gold quick-quote-btn">
          Get a Quote <i className="fas fa-arrow-right ms-2" aria-hidden="true"></i>
        </button>
      </form>
      <p className={`quick-quote-note${error ? " is-error" : ""}`} role="status">
        {error || "We confirm availability and pricing with you before the ride is booked."}
      </p>
    </div>
  );
}
